



























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { OnBoardingData } from '@/models/home';
import { HomeHelper } from '@/services/home-helper';

import PoiCard from '@/components/poi-card.vue';
import { Poi } from '@/models/poi';

@Component({
    components: {
        PoiCard
    }
})
export default class HomeOnBoardingCard extends Vue {

    @Prop(Object) public onBoardingData: OnBoardingData;
    @Prop(Boolean) public inLoadingState: boolean;

    public onBoardingPoi: Poi = null;

    public async created() {
        if (this.onBoardingData && this.onBoardingData.poi) {
            this.onBoardingPoi = await this.$store.getPoi(this.onBoardingData.poi);
        }
    }

    public async closeOnBoardingCard() {
        HomeHelper.GetOnBoardingProgress(this.$store).userHasClickedAway = true;
        await HomeHelper.IncrementOnBoardingState(this.$store);
    }

    public poiTapped() {
        this.$f7router.navigate(`/pois/${this.onBoardingPoi.id}/`);
    }
}
